/**
 * search bar component
 *
 * @module search-bar
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = "search-bar";

if (!customElements.get(customElements.component)) {
  class searchBar extends HTMLElement {
    /**
     * search bar web component
     *
     * @constructor
     */
    constructor() {
      super();

      this.globalSearchBar =
        typeof this.dataset.globalSearchBar != "undefined" ? true : false;

      this.input = this.querySelector('input[type="search"]');

      if (this.globalSearchBar) {
        this.initPopularSearchTermsEvents();

        this.initCloseEvents();

        this.initOpenEvents();
      }
    }

    /**
     * start to listen the click button to close search bar
     *
     * @returns {undefined}
     */
    initCloseEvents() {
      this.searchOverlay = this.querySelector("[data-search-overlay]");

      // Close search bar when click on overlay
      this.searchOverlay?.addEventListener("click", (event) => {
        event.preventDefault();
        this.close();
      });

      // Close search bar  when click on close button
      this.querySelectorAll("[data-search-close]").forEach((btn) => {
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          this.close();
        });
      });

      // Close search bar on press escape
      window.addEventListener("escape", (event) => {
        this.close();
      });
    }

    /**
     * hide search bar
     *
     * @returns {undefined}
     */
    close() {
      this.disableFocusTrap();

      document.body.classList.remove("overflow-hidden");

      this.classList.add("-translate-y-5");
      this.classList.remove("translate-y-0");
      this.classList.add("opacity-0");
      this.classList.remove("opacity-100");

      this.searchOverlay?.classList.add("opacity-0");
      this.searchOverlay?.classList.remove("opacity-100");

      // We need to use set time out to avoid issues with menu animation
      setTimeout(() => {
        this.setAttribute("aria-hidden", "true");

        this.classList.add("hidden");
        this.classList.remove("block");

        this.searchOverlay?.classList.add("hidden");
      }, 500);
    }

    /**
     * open search bar when clicking on search icon
     *
     * @returns {undefined}
     */
    initOpenEvents() {
      let openButton = document.querySelectorAll("[data-search-open]");

      openButton.forEach((btn) => {
        btn.addEventListener("click", (event) => {
          event.preventDefault();
          this.open();
        });
      });
    }

    /**
     * show search bar
     *
     * @returns {undefined}
     */
    open() {
      this.classList.remove("hidden");
      this.classList.add("block");

      this.setAttribute("aria-hidden", "false");

      this.searchOverlay?.classList.remove("hidden");

      setTimeout(() => {
        this.searchOverlay?.classList.remove("opacity-0");
        this.searchOverlay?.classList.add("opacity-100");

        this.classList.add("translate-y-0");
        this.classList.remove("-translate-y-5");
        this.classList.add("opacity-100");
        this.classList.remove("opacity-0");

        document.body.classList.add("overflow-hidden");

        this.initFocusTrap();

        this.activeFocusTrap();

        this.querySelector("[data-search-input]").focus();
      }, 50);
    }

    /**
     * Init minicart focus trap
     *
     * @returns {undefined}
     */
    initFocusTrap() {
      this.focusTrap = focusTrap.createFocusTrap(this, {
        clickOutsideDeactivates: true,
      });
    }

    /**
     * Ative minicart focus trap
     *
     * @returns {undefined}
     */
    activeFocusTrap() {
      if (this.focusTrap) {
        this.focusTrap.activate();
      }
    }

    /**
     * Disable minicart focus trap
     *
     * @returns {undefined}
     */
    disableFocusTrap() {
      if (this.focusTrap) {
        this.focusTrap.deactivate();
      }
    }

    /**
     * Init popular search terms events
     *
     * @returns {undefined}
     */
    initPopularSearchTermsEvents() {
      this.popularSearchTerms = this.querySelector(
        "[data-popular-search-terms]"
      );

      this.input.addEventListener(
        "input",
        window.theme.debounce
          .apply((event) => {
            let searchTerm = this.input.value.trim();
            if (!searchTerm.length) {
              this.popularSearchTerms?.classList.remove("hidden");
            } else {
              this.popularSearchTerms?.classList.add("hidden");
            }
          }, 300)
          .bind(this)
      );
    }
  }

  customElements.define(customElements.component, searchBar);
}
